/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { UiBadgeVariant } from 'types/enums/UiBadgeVariant'

type UiBadgeProps = {
    children: React.ReactNode
    variant?: UiBadgeVariant | 'default' | 'success' | 'warning' | 'danger' | 'info' | 'purple'
    onClick?: () => void
    className?: string
}

const UiBadge: React.FC<UiBadgeProps> = ({
    children,
    variant = UiBadgeVariant.Default,
    onClick,
    className,
}) => {
    const baseClasses =
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium'

    const variantClasses: Record<string, string> = {
        [UiBadgeVariant.Default]: 'pill-tone-gray',
        [UiBadgeVariant.Success]: 'pill-tone-green',
        [UiBadgeVariant.Warning]: 'pill-tone-yellow',
        [UiBadgeVariant.Danger]: 'pill-tone-red',
        [UiBadgeVariant.Info]: 'pill-tone-blue',
        [UiBadgeVariant.Purple]: 'pill-tone-purple',
    }

    return (
        <span
            className={clsx(
                'UiBadge',
                baseClasses,
                variantClasses[variant as string],
                onClick && 'cursor-pointer',
                className
            )}
            onClick={onClick}
        >
            {children}
        </span>
    )
}

export default UiBadge
